import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as dropin from 'braintree-web-drop-in';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnvironmentService } from 'src/app/services/environment/environment.service';
import { ProfessionalService } from 'src/app/services/professional/professional.service';
import { RealtorService } from 'src/app/services/realtors/realtor.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonConstants } from 'src/app/constants/commonConstants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PaymentModel, RealtorPlan } from 'src/app/models/PaymentModel';

@Component({
	selector: 'app-upgrade-payment',
	templateUrl: './upgrade-payment.component.html',
	styleUrls: ['./upgrade-payment.component.scss'],
	providers: [ConfirmationService, MessageService]

})
export class UpgradePaymentComponent implements OnInit {

	upgradeForm: FormGroup;
	submitted = false;
	xClientId: string;
	// realtorPlans: [] = [] as any;
	realtorPlans: RealtorPlan[];
	dropInInstance: dropin.DropinModel;
	validateCode: string = '';
	displayErrorPopup: boolean = false;
	errorMessage: string = '';
	errorHasButton: boolean = false;
	errorPromoCodeMessage: string = '';
	validPromoCodeMessage: string = '';
	userProfile: any;
	realtorPaymentDetails: any;
	realtorFN: string = '';
	_payload = {
		"PaymentMethodToken": '',
		"MembershipPlanCode": '',
		"MembershipPlanId": '',
		"Code": '',
		"ZipCodes": '',
		"promoCode": '',
	};
	termsAndConditons: any;
	tcURL: SafeResourceUrl | null = null;
	tcHeader: string = '';
	price: string;
	selectedPlan: string = '';
	isBraintreeInitialized: boolean = false;
	uniquePlanCategories: string[] = [];
	selectedCategory: string = '';
	iOSStoreUrl: string;
	androidStoreUrl: string;
	displayZipCodeInput: boolean = false;
	zipCodes: string = '';
	zipCodeError: string | null = null;
	maxZipCodesAllowed: number = 0;
	upgradeDescription: string = '';

	// The backend annotates the caller's current plan (in realtorPlans) with these two fields -
	// see Lightning\Functions\Payment\Plan.cs. Read off whichever plan has them set, since that's
	// the one matching the person's existing PersonMembershipPlan row.
	get currentPlanStatus(): string | undefined {
		return this.realtorPlans?.find(p => p.currentPlanStatus)?.currentPlanStatus;
	}
	get currentPlanHoldStartDate(): string | undefined {
		return this.realtorPlans?.find(p => p.currentPlanStatus)?.currentPlanHoldStartDate;
	}
	private get currentMatchedPlan(): RealtorPlan | undefined {
		return this.realtorPlans?.find(p => !!p.currentPlanPromoCode);
	}
	get currentPlanPromoCode(): string | undefined {
		return this.currentMatchedPlan?.currentPlanPromoCode;
	}
	// Free-plan + promo signups store the promo-variant plan's id against the person, resolved
	// back to the base Free plan on the backend (see Plan.cs) - shown as "Free with promo (CODE)"
	// per the agreed display format. Paid plans never go through that swap, so any promo code on a
	// paid plan is shown plainly against that plan's own title instead.
	get currentPlanPromoLabel(): string | undefined {
		const plan = this.currentMatchedPlan;
		if (!plan?.currentPlanPromoCode) return undefined;
		const isFree = plan.price?.toLowerCase() === 'free';
		return isFree
			? `Free with promo (${plan.currentPlanPromoCode})`
			: `${plan.title || plan.description} with promo (${plan.currentPlanPromoCode})`;
	}

	get currentPlanBannerLabel(): string | undefined {
		if (this.currentPlanPromoLabel) return this.currentPlanPromoLabel;
		const plan = this.realtorPlans?.find(p => p.currentPlanStatus);
		if (!plan) return undefined;
		const isFree = (plan.price ?? '').toLowerCase() === 'free';
		if (isFree) return undefined;
		const title = plan.title || 'Your current plan';
		return `${title} — ${plan.price}/month`;
	}
	private readonly TRIAL_PROMOS_REQUIRING_CC = new Set<string>([
  '30DAYFREETRIAL'
]);
private readonly DISABLE_PROMO_FOR_CODES = new Set<string>(['FREETRIAL9']);
private readonly ANNUAL_PLAN_CODES = new Set(['ANNUALTOOLBOX99']);
private readonly PAID_PLAN_ONLY_PROMOS = new Set<string>(['DOUBLELEADS']);

private readonly TRIAL_ONLY_MSG =
  'This promo code is only valid with the "Promo Code Offer: Free" plan. ' +
  'Please select **Promo Code Offer: Free**, apply the code, and your first 30 days will be free. ' +
  'After 30 days, it auto-renews at $19/month until you cancel.';

private readonly PAID_PLAN_ONLY_MSG =
  'This promo code is only valid with a paid domiiProspects plan. Please select a paid plan to apply this code.';

	constructor(
		private formBuilder: FormBuilder,
		private realtorService: RealtorService,
		private professionalService: ProfessionalService,
		private environmentService: EnvironmentService,
		private router: Router,
		private spinner: NgxSpinnerService,
		private route: ActivatedRoute,
		private sanitizer: DomSanitizer,
	) {
		this.validateCode = this.route.snapshot.params['code'];
		this._payload.Code = this.validateCode;
		this.xClientId = this.environmentService.getXClientId();
	}

	ngOnInit(): void {
		this.buildUpgradeForm();
		this.validate();
		this.androidStoreUrl = this.environmentService.getAndroidStoreUrl();
		this.iOSStoreUrl = this.environmentService.getiOSStoreUrl();
		this.applyPromoEnablement(); // <-- NEW call
	}

	selectCategory(category: string): void {
		this.selectedCategory = category;
	}

	buildUpgradeForm() {
		this.upgradeForm = this.formBuilder.group({
			agreeTandC: new FormControl(false, [Validators.requiredTrue]),
			membershipPlan: new FormControl('', [Validators.required]),
			zipCode: new FormControl(''),
			promocode: new FormControl(''),
		});
	}

	validate() {
		let url = this.environmentService.getIA9LightningUrl() + 'V3/payment/update/' + this.validateCode + '?code=' + this.environmentService.getIA9LightningKey();
		this.spinner.show();
		this.realtorService.validateCode(url, this.xClientId).subscribe((response: any) => {
			this.retrievePlans();
			this.spinner.hide();
		},
			(error) => {
				this.spinner.hide();
				this.errorMessage = error.error.description;
				if (error.error.statusCode === 6001) {
					this.errorMessage = "Account upgrade already completed.<br />You may now close this page.";
				}
				if (error.error.statusCode === 6002) {
					this.errorMessage = "Pending Verification of license status within 48 Business hours.<br /> We will send you an email once approved, thank you for your patience.";
				}
				if (error.error.statusCode === 6003) {
					this.errorMessage = "Your profile is incomplete, please update your profile information <a href='https://account-staging.domii.io/profile'>here</a>.";
				}
				document.getElementById('failedBtn').click();
			});
	}

	validatePromoCode(promoCode) {
		this.errorPromoCodeMessage = "";
		this.validPromoCodeMessage = "";
		this._payload.promoCode = "";

 // pre-API guard
if (this.isTrialPromo() && this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.TRIAL_ONLY_MSG;
  this.validPromoCodeMessage = '';
  this._payload.promoCode = '';
  this.upgradeForm.get('promocode')?.setValue('');
  return;
}

// pre-API guard: paid-plan-only promos (e.g. DOUBLELEADS) cannot be used with the Free plan
if (this.isPaidPlanOnlyPromo(promoCode) && !this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.PAID_PLAN_ONLY_MSG;
  this.validPromoCodeMessage = '';
  this._payload.promoCode = '';
  this.upgradeForm.get('promocode')?.setValue('');
  return;
}
		let url = `${this.environmentService.getIA9LightningUrl()}payment/promo/plans?code=${this.environmentService.getIA9LightningKey()}&pCode=${promoCode}`;
		this.spinner.show();
		this.realtorService.validateCode(url, this.xClientId).subscribe((response: any) => {

			// post-API guard (defense in depth)
    const code = (promoCode || '').toString().trim().toUpperCase();
if (this.TRIAL_PROMOS_REQUIRING_CC.has(code) && this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.TRIAL_ONLY_MSG;
  this.upgradeForm.get('promocode')?.setValue('');
  this._payload.promoCode = '';
  return;
}
			if (response.statusCode === 2000) {
				this.validPromoCodeMessage = "VALID";
				this._payload.promoCode = (this.upgradeForm.get('promocode')?.value ?? '').trim();
			}
			this.spinner.hide();
			if (this.selectedPlan === 'Free') {
  if (this.isTrialPromo()) {
    this.spinner.show(); this.createDropIn();
  } else if (this.isBraintreeInitialized && this.dropInInstance) {
    this.dropInInstance.teardown(err => { if (err) console.error(err); this.isBraintreeInitialized = false; });
  }
}
		},
			(error) => {
				this.spinner.hide();
				this.errorPromoCodeMessage = error?.error?.description || "INVALID";
				// if user is on Free and code turned invalid, ensure CC panel is off
if (this.selectedPlan === 'Free' && this.isBraintreeInitialized && this.dropInInstance) {
  this.dropInInstance.teardown(err => { if (err) console.error(err); this.isBraintreeInitialized = false; });
}
			});
	}

	onApplyPromoCode() {
		const promocode = this.upgradeForm.get('promocode').value;
		if (promocode === "") {
			this.errorPromoCodeMessage = "Please enter promo code";
			return;
		} 
		
		 // Fast guard before hitting API
  if (this.TRIAL_PROMOS_REQUIRING_CC.has((promocode || '').toString().trim().toUpperCase()) && this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.TRIAL_ONLY_MSG;
  this.validPromoCodeMessage = '';
  this._payload.promoCode = '';
  this.upgradeForm.get('promocode')?.setValue('');
  return;
}

  // Fast guard before hitting API: paid-plan-only promos (e.g. DOUBLELEADS) cannot be used with the Free plan
  if (this.isPaidPlanOnlyPromo(promocode) && !this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.PAID_PLAN_ONLY_MSG;
  this.validPromoCodeMessage = '';
  this._payload.promoCode = '';
  this.upgradeForm.get('promocode')?.setValue('');
  return;
}

			this.validatePromoCode(this.upgradeForm.get('promocode').value);
	}

	validateZipCode() {
		const zipCodeControl = this.upgradeForm.get('zipCode');
		if (this.selectedPlan) {
			const plan = this.realtorPlans.find(plan => plan.price === this.selectedPlan);
			if (plan) {
				this.maxZipCodesAllowed = plan.limits?.MaxZipCodeAllowed || 0;
			}
		}

		// AC-4326: Zip codes were no longer mandatory for lead plans ($99 and up).
		// Root cause: the empty-value guard (if (!raw) return null) was placed before the
		// maxZipCodesAllowed check, allowing users to submit with no zip codes entered.
		// Fix: check maxZipCodesAllowed === 0 first (skip non-zip plans), then require
		// at least 1 zip code when the plan does require them.
		zipCodeControl.setValidators([
			(control) => {
				// Plans that don't use zip codes — skip validation entirely
				if (this.maxZipCodesAllowed === 0)
					return null;

				const raw = (control.value ?? '').toString().trim();

				// At least 1 zip code is required for lead plans ($99 and up)
				if (!raw) return { zipCodeRequired: true };

				const zipCodeRegex = /^\d+$/;
				const zipCodes = raw.split(/[\s,]+/).map(zip => zip.trim()).filter(zip => zip.length > 0);

				const invalidZipCodes = zipCodes.filter(zip => !zipCodeRegex.test(zip));
				if (invalidZipCodes.length > 0) {
					return { invalidZipCodes: invalidZipCodes };
				}

				if (zipCodes.length > this.maxZipCodesAllowed) {
					return { maxZipCodesExceeded: { max: this.maxZipCodesAllowed, actual: zipCodes.length } };
				}

				return null;
			}
		]);

		zipCodeControl.updateValueAndValidity({ emitEvent: false });
	}

	get form() { return this.upgradeForm.controls; }

	createDropIn() {
		const url = this.environmentService.getIA9LightningUrl() + 'registration/getpaymenttoken';
		this.professionalService.getClientAuthToken(url, this.xClientId).subscribe((response) => {
			if (response?.data) {
				dropin.create({
					authorization: response.data,
					container: document.getElementById('dropin-container')
				}).then((dropinInstance) => {
					this.dropInInstance = dropinInstance;
					this.isBraintreeInitialized = true;
					this.spinner.hide();
				}).catch((error) => { console.log(error) });
			}
		}, (error) => {
			this.spinner.hide();
			this.errorMessage = error.error.description;
			if (error.error.statusCode === 6001) {
				this.errorMessage = "Account upgrade already completed.<br />You may now close this page.";
			}
			if (error.error.statusCode === 6002) {
				this.errorMessage = "Pending Verification of license status within 48 Business hours.<br /> We will send you an email once approved, thank you for your patience.";
			}
			if (error.error.statusCode === 6003) {
				this.errorMessage = "Your profile is incomplete, please update your profile information <a href='https://account-staging.domii.io/profile'>here</a>.";
			}
			document.getElementById('failedBtn').click();
		});
	}

	retrievePlans() {
		const url = this.environmentService.getIA9LightningUrl() + 'payment/realtorupgrade/plans?pcode=' + this._payload.Code + '&code=' + this.environmentService.getIA9LightningKey();
		this.spinner.show();
		this.professionalService.getMembershipPlansRealtors(url, this.xClientId).subscribe((response) => {
			if (response?.data) {
				// this.realtorPlans = response?.data;
				this.realtorPlans = response?.data.map((plan) => {
					return {
						...plan,
						featureSet: this.jsonParse(plan.featureSet),
						limits: this.jsonParse(plan.limits),
						// Don't pre-select the current plan — force user to actively pick a different one
						selected: plan.currentPlanStatus ? false : plan.selected,
					};
				});
				this.getPlanData();

				// ADDED: hydrate form/state from any plan that is already marked selected
				this.hydrateSelectionFromPrecheckedPlan(); // <-- ADDED
			}
		}, (error) => {
			this.spinner.hide();
			this.errorMessage = error.error.description;
			if (error.error.statusCode === 6001) {
				this.errorMessage = "Account upgrade already completed.<br />You may now close this page.";
			}
			if (error.error.statusCode === 6002) {
				this.errorMessage = "Pending Verification of license status within 48 Business hours.<br /> We will send you an email once approved, thank you for your patience.";
			}
			if (error.error.statusCode === 6003) {
				this.errorMessage = "Your profile is incomplete, please update your profile information <a href='https://account-staging.domii.io/profile'>here</a>.";
			}
			document.getElementById('failedBtn').click();
		});
	}

	jsonParse(json: string | null): any {
		try {
			return json ? JSON.parse(json) : {};
		} catch (e) {
			console.error('Invalid JSON:', json, e);
			return {};
		}
	}

	radioChecked(data: any, i: number) {
		if (data.currentPlanStatus) return;

		// Clear promo messages on plan change
this.errorPromoCodeMessage = '';
this.validPromoCodeMessage = '';

		if (this.isBraintreeInitialized) {
			this.dropInInstance.teardown(function (err) {
				if (err) { console.error('An error occurred during teardown:', err); }
			});
		}

		 // NEW: require CC if (a) paid plan OR (b) Free + (trial promo OR FREETRIAL9 plan)
  const requiresCC =
    data.price !== 'Free' ||
    (data.price === 'Free' && (this.isTrialPromo() || this.isFreeTrialPlanCode(data.code)));

		if (requiresCC) {
			this.spinner.show();
			this.createDropIn();
		} else {
			this.isBraintreeInitialized = false;
		}

		// this.realtorPlans.forEach((item: any) => {
		// 	if (item.uid !== data.uid) {
		// 		item.selected = false;
		// 	} else {
		// 		item.selected = true;
		// 	}
		// });
		 this.realtorPlans.forEach((item: any) => {
    item.selected = (item.uid === data.uid);
  });

		this.upgradeForm.get("membershipPlan").patchValue(data.code);
		this._payload.MembershipPlanCode = data.code;
		this._payload.MembershipPlanId = data.uid;
		this.selectedPlan = data.price;

		 // Promo guard: trial code cannot be used with paid plans
  if (this.isTrialPromo() && this.isPaidPlanSelected()) {
    this.errorPromoCodeMessage = '';
    this.validPromoCodeMessage = '';
    this._payload.promoCode    = '';
    this.upgradeForm.get('promocode')?.setValue('');
  }

  // Promo guard: paid-plan-only promos (e.g. DOUBLELEADS) cannot be used with the Free plan
  if (this.isPaidPlanOnlyPromo() && !this.isPaidPlanSelected()) {
    this.errorPromoCodeMessage = '';
    this.validPromoCodeMessage = '';
    this._payload.promoCode    = '';
    this.upgradeForm.get('promocode')?.setValue('');
  }
		this.validateZipCode();
this.upgradeForm.updateValueAndValidity({ emitEvent: false });
		const hasZipInput = (data?.featureSet?.AllowZipCodes === 'Yes');
		const zipCodeControl = this.upgradeForm.get('zipCode');
		//const selectedZipCode = document.getElementById(`zipCode-${i}`);

		// if (this.selectedPlan) {
		// 	zipCodeControl.setValue('');
		// 	selectedZipCode.focus();
		// }

		
    if (hasZipInput) {
      zipCodeControl?.setValue('');
      // wait for Angular to render the input before focusing it
      setTimeout(() => {
        const el = document.getElementById(`zipCode-${i}`) as HTMLInputElement | null;
        el?.focus();
      }, 0);
    } else {
      // ensure no stale value
      zipCodeControl?.setValue('');
    }

		 this.applyPromoEnablement(data.code);  // NEW: toggle promo enablement whenever plan changes
	}

	isTrialPromo(): boolean {
  const v = (this.upgradeForm.get('promocode')?.value || '').toString().trim().toUpperCase();
  return v === '30DAYFREETRIAL';
}

	/** True when the given (or currently entered) promo code is restricted to paid plans only (e.g. DOUBLELEADS) */
	isPaidPlanOnlyPromo(code?: string): boolean {
  const v = (code ?? this.upgradeForm.get('promocode')?.value ?? '').toString().trim().toUpperCase();
  return this.PAID_PLAN_ONLY_PROMOS.has(v);
}

	onSubmit() {
		this.submitted = true;
		console.log('submit clicked', this.upgradeForm.value, this.upgradeForm.invalid);
		if (this.upgradeForm.invalid) {
			Object.values(this.upgradeForm.controls).forEach(c => c.markAsTouched());
			if (this.upgradeForm.get('zipCode')?.invalid) {
				const idx = this.realtorPlans?.findIndex(p => p.selected) ?? -1;
				if (idx >= 0) {
					setTimeout(() => {
						const el = document.getElementById(`zipCode-${idx}`) as HTMLInputElement | null;
						el?.focus();
						el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}, 0);
				}
			}
			return;
		}

		// NEW: block trial promo on paid plans at submit time
if (this.isTrialPromo() && this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.TRIAL_ONLY_MSG;
  this.validPromoCodeMessage = '';
  this._payload.promoCode = '';
  return;
}

// block paid-plan-only promos (e.g. DOUBLELEADS) on the Free plan at submit time
if (this.isPaidPlanOnlyPromo() && !this.isPaidPlanSelected()) {
  this.errorPromoCodeMessage = this.PAID_PLAN_ONLY_MSG;
  this.validPromoCodeMessage = '';
  this._payload.promoCode = '';
  return;
}

		// Only send zip codes for plans whose featureSet actually allows them.
		const allowsZipCodes = this.getSelectedPlan()?.featureSet?.AllowZipCodes === 'Yes';
		this._payload.ZipCodes = allowsZipCodes
			? (this.upgradeForm.get('zipCode')?.value ?? '').toString().trim()
			: '';

		const promoCode = (this.upgradeForm.get('promocode')?.value ?? '').trim();
		if (this._payload.promoCode === "" && promoCode !== "") {
			let url = `${this.environmentService.getIA9LightningUrl()}payment/promo/plans?code=${this.environmentService.getIA9LightningKey()}&pCode=${promoCode}`;
			this.spinner.show();
			this.errorPromoCodeMessage = "";
			this.validPromoCodeMessage = "";
			this._payload.promoCode = "";
			this.realtorService.validateCode(url, this.xClientId).subscribe((response: any) => {
				this.validPromoCodeMessage = response.description;
				this._payload.promoCode = promoCode;
				this.spinner.hide();
				if (this.selectedPlan !== 'Free') {
					this.dropInInstance.requestPaymentMethod().then((payload) => {
						this.upgradeAccount(payload);
					}).catch((error) => { console.log(error) });
				} else {
					this.upgradeAccount();
				}
			},
				(error) => {
					this.spinner.hide();
					this.errorPromoCodeMessage = error.error.description;
				});
		} else {
			if (this.errorPromoCodeMessage === "") {

				if (this.selectedPlan !== 'Free'  || (this.selectedPlan === 'Free' && this.isTrialPromo())) {
					this.dropInInstance.requestPaymentMethod().then((payload) => {
						this.upgradeAccount(payload);
					}).catch((error) => { console.log(error) });
				} else {
					this.upgradeAccount();
				}
			}
		}

	}

	upgradeAccount(payload?) {
		this._payload.PaymentMethodToken = '';
		if (this.selectedPlan !== 'Free'|| (this.selectedPlan === 'Free' && this.isTrialPromo())) {
			this._payload.PaymentMethodToken = payload.nonce;
		}

		const uploadPayload = new PaymentModel();
		uploadPayload.paymentMethodToken = this._payload.PaymentMethodToken;
		uploadPayload.membershipPlanCode = this._payload.MembershipPlanCode;
		uploadPayload.membershipPlanId = this._payload.MembershipPlanId;
		uploadPayload.code = this._payload.Code;
		uploadPayload.promoCode = this._payload.promoCode;
		uploadPayload.ZipCodes = this._payload.ZipCodes;

		const url = this.environmentService.getIA9LightningUrl() + 'V3/payment/update?code=' + this.environmentService.getIA9LightningKey();
		this.spinner.show();
		this.realtorService.realtorPayment(url, uploadPayload, this.xClientId).subscribe((response) => {
			this.upgradeDescription = (response as { description: string })?.description;
			setTimeout(() => {
				document.getElementById('successBtn').click();
				this.spinner.hide();
			}, 2000);
		},
			(error) => {
				this.displayErrorPopup = true;
				this.spinner.hide();
				this.errorMessage = error.error.description;
				this.errorHasButton = true;
				if (error.error.statusCode === 10005) {
					this.errorHasButton = true;
				}
				if (error.error.statusCode === 6001) {
					this.errorMessage = "Account upgrade already completed.<br />You may now close this page.";
					this.errorHasButton = false;
				}
				if (error.error.statusCode === 6002) {
					this.errorMessage = "Pending Verification of license status within 48 Business hours.<br /> We will send you an email once approved, thank you for your patience.";
					this.errorHasButton = false;
				}
				if (error.error.statusCode === 6003) {
					this.errorMessage = "Your profile is incomplete, please update your profile information <a href='https://account-staging.domii.io/profile'>here</a>.";
					this.errorHasButton = false;
				}
				document.getElementById('failedBtn').click();
			});
	}

	openTerms(event, type) {
		event.preventDefault();
		document.getElementById('openTermsConditionsBtn').click();
		(document.getElementById('t&CLogo') as HTMLImageElement).src = CommonConstants.imageBasePath + this.environmentService.getCompanyLogo();
		let url = '';
		if (type == 'TC') {
			this.tcHeader = 'Terms and Conditions';
			url = this.environmentService.getEULAUrl();
		}
		else if (type == 'PP') {
			this.tcHeader = 'Privacy Policy';
			url = this.environmentService.getPrivacyUrl();
		}
		this.tcURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
		
	}

	clearTermsUrl() { this.tcURL = null; }

	getPlanData() {
		this.uniquePlanCategories = [...new Set(this.realtorPlans.map(plan => plan.planCategoryDescription))].filter(Boolean).sort();
		this.selectedCategory = this.uniquePlanCategories[0];
	}

	openAppStore() {
		window.open(this.iOSStoreUrl);
	}

	openPlayStore() {
		window.open(this.androidStoreUrl);
	}

	reloadPage() {
		location.reload();
	}

	showMoreInfo: boolean = false;

	toggleMoreInfo(): void {
		this.showMoreInfo = !this.showMoreInfo;
	}

	cleanDescription(html: string): string {
		return html.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
	}

	onPromoCodeInput(): void {
  const raw = this.upgradeForm.get('promocode')?.value ?? '';
  const cleaned = raw.replace(/\s/g, '');
  if (cleaned !== raw) {
    this.upgradeForm.get('promocode')?.setValue(cleaned, { emitEvent: false });
  }
  const isFree = (this.selectedPlan || '').toString().trim().toLowerCase() === 'free';
  const code = cleaned.toUpperCase();
  const isTrial = (code === '30DAYFREETRIAL');

  // Free + trial → ensure CC panel is visible
  if (isFree && isTrial) {
    if (!this.isBraintreeInitialized) {
      this.spinner.show();
      this.createDropIn();
    }
    return;
  }

  // Free + NOT trial → hide CC panel if it’s shown
  if (isFree && this.isBraintreeInitialized && this.dropInInstance) {
    this.dropInInstance.teardown(err => {
      if (err) console.error(err);
      this.isBraintreeInitialized = false;
    });
  }
}

	  /** Detect whether the currently selected plan is the $114 annual plan */
  private isSelectedAnnual99(): boolean {
   const code = (this.upgradeForm.get('membershipPlan')?.value || '')
    .toString()
    .trim()
    .toUpperCase();
  return this.ANNUAL_PLAN_CODES.has(code);
  }

   /** Toggle promo input based on selected plan; clears value/messages when disabling */
  private applyPromoEnablement(planCode?: string): void {
    const ctrl = this.upgradeForm.get('promocode');
    if (!ctrl) return;

	const codeU = (planCode ?? '').toString().trim().toUpperCase();
  const isFreeTrial9 = codeU === 'FREETRIAL9';

    // Disable if annual $99 OR code is FREETRIAL9
  const shouldDisable = this.isSelectedAnnual99() || isFreeTrial9;

    if (shouldDisable) {
      ctrl.reset('', { emitEvent: false });
      ctrl.disable({ emitEvent: false });
      this.errorPromoCodeMessage = '';
      this.validPromoCodeMessage = '';
      this._payload.promoCode = '';
    } else {
      if (ctrl.disabled) {
        ctrl.enable({ emitEvent: false });
      }
    }
	  // check to ensure the parent form re-evaluates
  ctrl.updateValueAndValidity({ emitEvent: false });
  this.upgradeForm.updateValueAndValidity({ emitEvent: false });
  }

  private isPaidPlanSelected(): boolean {
  // prefer actual selected plan from form; fall back to selectedPlan text
  const price = ((this.getSelectedPlan()?.price ?? this.selectedPlan) || '')
                  .toString().trim().toLowerCase();
  return price !== 'free';
}


private getSelectedPlan(): RealtorPlan | undefined {
  const code = this.upgradeForm.get('membershipPlan')?.value;
  return this.realtorPlans?.find(p => p.code === code);
}

private isFreeTrialPlanCode(code?: string): boolean {
  return (code ?? '').toString().trim().toUpperCase() === 'FREETRIAL9';
}
private isFreeTrialPlanSelected(): boolean {
  const code = this.upgradeForm.get('membershipPlan')?.value;
  return this.isFreeTrialPlanCode(code);
}

	// ==== hydrate selection if a plan is pre-checked and user didn’t click radio ====
	private hydrateSelectionFromPrecheckedPlan(): void {
		const pre = this.realtorPlans?.find(p => p.selected);
		if (!pre) return;

		// make the form valid (required control) and sync internal state
		this.upgradeForm.get('membershipPlan')?.setValue(pre.code);
		this._payload.MembershipPlanCode = pre.code;
		this._payload.MembershipPlanId   = pre.uid;
		this.selectedPlan                = pre.price ?? '';

		// enforce promo enablement/disablement rules based on plan code
		this.applyPromoEnablement();

		// if this selection requires CC, initialize drop-in so submit path works
		const requiresCC =
			this.selectedPlan !== 'Free' ||
			(this.selectedPlan === 'Free' && (this.isTrialPromo() || this.isFreeTrialPlanCode(pre.code)));

		if (requiresCC && !this.isBraintreeInitialized) {
			this.spinner.show();
			this.createDropIn();
		}
	}
	// ==== END====

}